import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, Section, Loading } from "../components/Common";

export default function Sports() {
  const [clubs, setClubs] = useState(null);
  useEffect(() => { api.sportsClubs().then(({ data }) => setClubs(data)); }, []);
  if (clubs === null) return <Loading />;
  const grouped = clubs.reduce((a, c) => { (a[c.category] = a[c.category] || []).push(c); return a; }, {});
  return (
    <div data-testid="sports-page">
      <PageHeader kicker="Sports & Enrichment" title="Clubs, Sports & Societies" subtitle="Co-curricular life at Highlands." />
      {Object.entries(grouped).map(([cat, list]) => (
        <Section key={cat} title={cat[0].toUpperCase() + cat.slice(1)} testId={`sports-${cat}`}>
          <div className="grid md:grid-cols-3 gap-4">
            {list.map((c) => (
              <div key={c.id} className="hl-card p-5">
                <div className="overline">{c.category}</div>
                <div className="font-display font-bold text-lg tracking-tight">{c.name}</div>
                <div className="text-xs text-slate-500 mt-1">Schedule: {c.schedule}</div>
                <div className="text-xs text-slate-500 mt-2">{(c.student_ids || []).length} members</div>
              </div>
            ))}
          </div>
        </Section>
      ))}
    </div>
  );
}
